<div class="container-wrapper">
    <div class="content-wrapper">
        <div class="video-title">
          <span role="heading"
                aria-atomic="true"
                aria-live="assertive">{{imageDetail.program}} ({{imageDetail.booktitle}})</span>
        </div>
        <div *ngFor="let item of asset" class="asset-wrapper" [ngClass]="{'iframe':isIframe}">
            <div [ngSwitch]="item.extension" class="asset-container">
                <div *ngSwitchCase="'mp4'" class="asset">
                    <video autoplay class="video-player" controls>
            <source [src]="item.url" type="video/mp4">
          </video>
                </div>
                <div *ngSwitchCase="'pdf'" class="asset">
                    <pdf-viewer [src]="{ url: item.url, isEvalSupported: false }"
                                [original-size]="false"
                                [fit-to-page]="true"></pdf-viewer>
                </div>
                <div *ngSwitchDefault class="asset-iframe">
                    <iframe #iframe
                            scrolling="no"
                            [title]="imageDetail.program"
                            *ngFor="let ass of asset"
                            [src]="item.url" frameborder="0"></iframe>
                </div>
            </div>
        </div>
    </div>
    <div class="multi button-container-wrapper">
        <div class="button-container">
            <button aria-label="Go Back"
                    class="back" (click)="toggleScan('back')">&lsaquo; Back</button>
            <button
              aria-label="Take another Picture"
              class="take-another-pic" (click)="toggleScan('scan')">Take Another Picture</button>
            <div aria-label="Turn on Flash"  class="flash" *ngIf="hasFlash" (click)="toggleScan('scan')"></div>
            <div class="flash-disabled" *ngIf="!hasFlash"></div>
        </div>
    </div>
</div>
